import React from "react";

const FORMAT_ACTIONS = [
  { id: "bold", label: "B", title: "Bold (Ctrl+B)", className: "format-bold" },
  { id: "italic", label: "I", title: "Italic (Ctrl+I)", className: "format-italic" },
  { id: "link", label: "Link", title: "Add link (Ctrl+K)", className: "format-link" },
];

const ChatComposerFormatToolbar = ({ onFormat, disabled }) => (
  <div
    className="conversation-view-format-toolbar"
    role="toolbar"
    aria-label="Message formatting"
  >
    {FORMAT_ACTIONS.map((action) => (
      <button
        key={action.id}
        type="button"
        className={`conversation-view-format-button ${action.className}`}
        onClick={() => onFormat(action.id)}
        disabled={disabled}
        title={action.title}
        aria-label={action.title}
      >
        {action.label}
      </button>
    ))}
  </div>
);

export default ChatComposerFormatToolbar;
